<template>
  <div>
    <a-table
      :columns="columns"
      :row-key="(record) => record.objId"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <template slot="operate" slot-scope="text, operate">
        <a v-on:click="topage(`/home/packageLog/packageLogInfo?objId=${operate.objId}`)" @click="edit">详情</a>
      </template>
    </a-table>
  </div>
</template>
<script>
import {
  listGoodsMallLog
} from "@/api/storeApi.js";

const columns = [
  {
    title: "操作类型",
    dataIndex: "operationType",
    align: "center",
  },
  {
    title: "新数据",
    align: "center",
    dataIndex: "newData",
    ellipsis: true
  },
  {
    title: "旧数据",
    dataIndex: "oldData",
    align: "center",
    ellipsis: true
  },
  {
    title: "用户uid",
    dataIndex: "uid",
    align: "center",
  },
  {
    title: "用户名称",
    dataIndex: "userName",
    align: "center",
  },
  {
    title: "操作时间",
    dataIndex: "createTime",
    align: "center",
  },
  {
    title: "操作",
    dataIndex: "name",
    scopedSlots: { customRender: "operate" },
  },
];

export default {
  data() {
    return {
      data: [],
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      loading: false,
      columns,
    };
  },
  mounted() {
    this.getTokensListData();
  },
  props: ["formInline"],
  methods: {
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    // 编辑
    edit() {},
    // 分页按钮
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      listGoodsMallLog(10, this.pagination.current, this.formInline.operationType).then((res) => {
        this.data = res.data;
      });
      this.loading = false;
    },
    query() {
      this.loading = true;
      listGoodsMallLog(
        this.formInline.limit,
        this.formInline.page,
        this.formInline.operationType
      ).then((res) => {
        this.loading = false;
        this.data = res.data;
        this.pagination.total = res.count;
      });
    },
    // 分页数据
    getTokensListData() {
      this.loading = true;
      listGoodsMallLog(10, 1, this.formInline.operationType).then((res) => {
        this.loading = false;
        this.pagination.total = res.count;
        this.data = res.data;
      });
    },
  },
};
</script>
<style scoped>
img {
  width: 110px;
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/marketingManagement/packageLog/packageLogContent.vue